import React, { useRef, useState, useCallback, useEffect } from 'react'
import hash from 'object-hash'

import {
  PasswordRequestWrapper,
  PasswordRequestLogo,
  PasswordRequestInputWrapper,
  PasswordRequestInput,
  PasswordRequestEye,
  PasswordRequestButton
} from './index.styled'

const LayoutPasswordRequest = ({ password, onLoginSuccess, isExiting }) => {
  const [error, setError] = useState(false)
  const [showPassword, setShowPassword] = useState(false)
  const inputRef = useRef()

  const login = useCallback(() => {
    console.log('Logging in', inputRef.current.value)
    if (password === hash.sha1(inputRef.current.value)) {
      setError(false)
      try {
        sessionStorage.setItem('accessPass', inputRef.current.value)
      } catch (error) {
        console.warn('No access to sessionStorage')
      }
      onLoginSuccess && onLoginSuccess(true)
    } else {
      setError(true)
    }
  }, [password, onLoginSuccess, inputRef])

  useEffect(() => {
    try {
      const savedPass = sessionStorage.getItem('accessPass')
      if (savedPass && hash.sha1(savedPass) === password) {
        onLoginSuccess(true)
      }
    } catch (error) {
      console.warn('No access to sessionStorage')
    }
  }, [password, onLoginSuccess])

  const handleKeyDown = useCallback((e) => {
    if (e.key === 'Enter') {
      login()
    }
  }, [login])

  return (
    <PasswordRequestWrapper>
      <PasswordRequestLogo $isExiting={isExiting} />
      <PasswordRequestInputWrapper $isExiting={isExiting}>
        <PasswordRequestInput
          ref={inputRef}
          placeholder='PASSWORD'
          type={showPassword ? 'text' : 'password'}
          className={error && 'error'}
          onKeyDown={handleKeyDown}
        />
        <PasswordRequestEye onClick={() => setShowPassword(prev => !prev)} $showPassword={showPassword} />
      </PasswordRequestInputWrapper>
      <PasswordRequestButton onClick={login} $isExiting={isExiting}>LOG IN</PasswordRequestButton>
    </PasswordRequestWrapper>
  )
}

export default LayoutPasswordRequest
